import {
  baseGoerli,
  goerli,
  mainnet,
  optimism,
  base,
  Chain
} from "wagmi/chains"

export const sliceChains: (chainId: string | number) => Chain[] = (
  chainId: string | number
) => {
  if (Number(chainId) == 1) {
    return [mainnet]
  } else if (Number(chainId) == 5) {
    return [goerli]
  } else if (Number(chainId) == 10) {
    return [optimism]
  } else if (Number(chainId) == 8453) {
    return [base, mainnet]
  } else if (Number(chainId) == 84531) {
    return [baseGoerli, goerli, mainnet]
  }
  return []
}
